import {
  Button,
  Checkbox,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
  useColorModeValue
} from "@chakra-ui/react";
import HourGlassImage from "assets/images/hourglass.png";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function TrialEndingModal({ isOpen, onClose }) {
  const navigate = useNavigate();
  const bgColor = useColorModeValue("background.light", "background.dark");
  const darkPurple = useColorModeValue("#1b1845", "#8671cc");
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const handleDismissal = () => {
    if (dontShowAgain) {
      localStorage.setItem("hideTrialModal", "true");
      localStorage.setItem("hideTrialModalDate", new Date().toISOString().split("T")[0]);
    }
  }

  const handleUpgradeClick = () => {
    handleDismissal();
    onClose();
    navigate("/pricing");
  };

  const handleClose = () => {
    handleDismissal();
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} isCentered size={'xl'}>
      <ModalOverlay />
      <ModalContent bg={bgColor} border="1px solid #FF60D5" borderRadius="20px">
        <ModalCloseButton />
        <ModalBody py={10} px={6}>
          <Flex alignItems={'center'} justifyContent={'center'} direction={'column'} gap={2}>
            <img src={HourGlassImage} alt="Hourglass" style={{ width: '40px', height: '40px' }} />
            <Text fontSize="2xl" fontWeight="bold">
              Your free trial is ending soon!
            </Text>
            <Text color={darkPurple} mb={'20px'}>Check out our plans and keep Hustlin’</Text>
            <Button colorScheme="brand" onClick={handleUpgradeClick} width={'150px'}>
              Explore
            </Button>
            <Checkbox
              mt={'20px'}
              fontSize={'14px'}
              colorScheme="brand"
              onChange={(e) => setDontShowAgain(e.target.checked)}
            >
              Don’t show this message again
            </Checkbox>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
